import getCustomerIdFromCookie from "../../../client/getCustomerIdFromCookie";
import hashString from "./hashString";

const getHashedCustomerIdPromise = () => {
  const customerIdFromCookie = getCustomerIdFromCookie();

  if (!customerIdFromCookie || customerIdFromCookie === "-1")
    return Promise.resolve();

  const hashedCustomerIdPromise = hashString(customerIdFromCookie);

  return hashedCustomerIdPromise;
};

export default getHashedCustomerIdPromise;
